import React from 'react';
import styled from 'styled-components';
import NewTabLink from './NewTabLink';
import { Label } from './Label';

export default ({ social }) => (
  <SocialIcons>
    {social.linkedInUrl && (
      <NewTabLink href={social.linkedInUrl}>
        <SocialLabel backgroundColor="#4875B4">LinkedIn</SocialLabel>
      </NewTabLink>
    )}
    {social.facebookUrl && (
      <NewTabLink href={social.facebookUrl}>
        <SocialLabel backgroundColor="#3b5998">Facebook</SocialLabel>
      </NewTabLink>
    )}
    {social.instagramUrl && (
      <NewTabLink href={social.instagramUrl}>
        <SocialLabel backgroundColor="#4E433C">Instagram</SocialLabel>
      </NewTabLink>
    )}
    {social.twitterUrl && (
      <NewTabLink href={social.twitterUrl}>
        <SocialLabel backgroundColor="#33CCFF">Twitter</SocialLabel>
      </NewTabLink>
    )}
    {social.youtubeUrl && (
      <NewTabLink href={social.youtubeUrl}>
        <SocialLabel backgroundColor="#ff0000">Youtube</SocialLabel>
      </NewTabLink>
    )}
  </SocialIcons>
);

const SocialLabel = styled(Label)`
  color: white;
  font-weight: bold;
  letter-spacing: 0.7px;
`;

const SocialIcons = styled.div`
  display: flex;

  & svg {
    width: 32px;
  }

  & > a:not(:last-child) {
    margin-right: 8px;
  }
`;
